var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { AccountTypeDict } from '../../../enum/EAccountType';
import { Prop, Watch } from 'vue-property-decorator';
import HeaderItem from "./HeaderItem.vue";
export var ToggleType;
(function (ToggleType) {
    ToggleType[ToggleType["prev"] = 1] = "prev";
    ToggleType[ToggleType["next"] = 2] = "next";
})(ToggleType || (ToggleType = {}));
var RecordHeader = (function (_super) {
    __extends(RecordHeader, _super);
    function RecordHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filter = {
            shop: [-1],
            account_date_start: new Date(),
            account_date_end: new Date(),
        };
        _this.typeDict = AccountTypeDict;
        _this.toggleType = ToggleType;
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            }
        };
        return _this;
    }
    RecordHeader.prototype.watchDetail = function (newDetail, oldDetail) {
        if (newDetail.business_id !== oldDetail.business_id) {
            this.filter.shop = [-1];
        }
        this.filter.account_date_start = this.detail.account_date_start.toDate();
        this.filter.account_date_end = this.detail.account_date_end.toDate();
    };
    RecordHeader.prototype.watchtreeClick = function (newDetail, oldDetail) {
        console.log(22, newDetail, oldDetail);
        if (newDetail) {
            this.filter.shop = [-1];
            this.filter.shop_ids = "-1";
        }
        newDetail = false;
    };
    RecordHeader.prototype.toggleLevel = function (type) {
        this.detail.account_val_times = this.detail.account_val_times || 0;
        var flag = type === ToggleType.prev ? 1 : -1;
        this.detail.account_val_times += flag;
        this.filter.account_val_times = this.detail.account_val_times;
        this.filterChange();
    };
    RecordHeader.prototype.filterChange = function () {
        this.filter.shop_ids = this.filter.shop.join(",");
        this.$emit('change', Object.assign({}, this.filter));
    };
    __decorate([
        Prop({
            type: Boolean
        })
    ], RecordHeader.prototype, "isHideUnAmount", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], RecordHeader.prototype, "detail", void 0);
    __decorate([
        Watch("detail")
    ], RecordHeader.prototype, "watchDetail", null);
    __decorate([
        Prop({
            required: true
        })
    ], RecordHeader.prototype, "treeClick", void 0);
    __decorate([
        Watch("treeClick")
    ], RecordHeader.prototype, "watchtreeClick", null);
    RecordHeader = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], RecordHeader);
    return RecordHeader;
}(Vue));
export default RecordHeader;
